import secureLocalStorageModule from "react-secure-storage";

const secureLocalStorage = (secureLocalStorageModule as unknown as {default?: typeof secureLocalStorageModule}).default ?? secureLocalStorageModule;

export class AuthenticationLocalService {

    removeAccessToken() {
        secureLocalStorage.removeItem("accessToken");
    }
    
    removeRefreshToken() {
        secureLocalStorage.removeItem("refreshToken");
    }
}